// extracted by mini-css-extract-plugin
module.exports = {"submitData":"MobileDesktopButton-module__submitData","btnLoading":"MobileDesktopButton-module__btnLoading"};